<template>
  <div class="w-100">
    <div style="width: 68%">
      <div class="d-flex">
        <div class="flex-grow-1 me-2">
          <div class="row">
            <div class="col" v-for="(title, i) in titleList" :key="i">
              <span class="text-danger" v-if="title.required">* </span>
              <label class="form-label">{{ title.name }}</label>
            </div>
          </div>
        </div>
        <!-- 占位 -->
        <div class="opacity-0">
          <b-button
            variant="primary"
            class="pb-0"
            size="sm"
            style="min-width: 4.5rem"
            >{{this.$t('page.solid')}}</b-button
          >
        </div>
      </div>
      <template v-if="showRepairs.length">
        <div
          class="d-flex mb-3"
          v-for="(repair, i) in showRepairs"
          :key="i"
        >
          <template v-if="!repair.is_deleted">
            <div class="flex-grow-1 me-2">
              <div class="row">
                <div class="col">
                  <input
                    type="text"
                    :class="[
                    'form-control',
                    submitted &&
                      (!repair.item_name || repair.item_name.length > 50) &&
                      'is-invalid',
                  ]"
                    :placeholder="this.$t('page.tending.enter_project_name')"
                    v-model="repair.item_name"
                    :disabled="repair.disabled"
                  />
                  <div
                    v-show="
                    submitted && (!repair.item_name || repair.item_name.length > 50)
                  "
                    class="invalid-feedback"
                  >
                  <span>{{
                      !repair.item_name
                        ? validationTips.nameNotNull
                        : validationTips.charLengthLE50
                    }}</span>
                  </div>
                </div>
                <div class="col">
                  <Multiselect
                    :class="[submitted && !repair.name && 'is-invalid']"
                    :placeholder="this.$t('page.tending.select_name')"
                    v-model="repair.name"
                    :close-on-select="true"
                    :searchable="false"
                    :canClear="false"
                    :options="maintenanceItemList"
                    value-prop="value"
                    label="label"
                    :disabled="repair.disabled"
                    @change="(selectedValue) => nameChange(selectedValue, i)"
                  />
                  <div
                    v-show="
                    submitted && !repair.name
                  "
                    class="invalid-feedback"
                  >
                  <span>{{
                      !repair.name
                        ? this.$t('page.tending.name_connot_be_null')
                        : ''
                    }}</span>
                  </div>
                </div>
                <div class="col">
                  <Multiselect
                    :class="[submitted && !repair.cycle && 'is-invalid']"
                    :placeholder="this.$t('page.tending.select_maintenance_period')"
                    v-model="repair.cycle"
                    :close-on-select="true"
                    :searchable="false"
                    :canClear="false"
                    :options="cycleOptions[i]"
                    value-prop="value"
                    label="label"
                    :disabled="repair.disabled"
                  />
                  <div
                    v-show="
                    submitted && !repair.cycle
                  "
                    class="invalid-feedback"
                  >
                  <span>{{
                      !repair.cycle
                        ? this.$t('page.tending.maintenance_period_cannot_be_empty')
                        : ''
                    }}</span>
                  </div>
                </div>
                <div class="col">
                  <div class="position-relative">
                  <textarea
                    class="form-control"
                    :placeholder="this.$t('page.tending.enter_description')"
                    rows="1"
                    maxlength="200"
                    v-model="repair.description"
                    :disabled="repair.disabled"
                  ></textarea>
                    <span
                      class="position-absolute fs-12"
                      style="bottom: 0.2rem; right: 0.5rem; color: #909399"
                    >{{
                        (repair.description && repair.description.length) || 0
                      }}/200</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="position-relative">
              <b-button
                variant="primary"
                size="sm"
                :style="{
                minWidth: '4.5rem',
                marginTop: ' 0.34rem',
                opacity: repair.disabled ? 0 : 1,
              }"
                :disabled="repair.disabled"
                @click="tagMessageBox = i"
              >{{this.$t('base.delete')}}</b-button
              >
              <MessageBox
                v-if="tagMessageBox == i"
                :messageCont="`${this.$t('page.product-library.AreYouSureWantDelete')}?`"
                :messageIcon="'ri-error-warning-line'"
                :iconStyle="{ fontSize: '14px', color: '#f06548' }"
                :messageStyle="{ top: '-6rem', left: '-3.5rem' }"
                @makeSure="handleDelete(i)"
                @makeClose="tagMessageBox = null"
              ></MessageBox>
            </div>
          </template>
        </div>
      </template>
    </div>
    <div class="text-center mt-2">
      <b-button variant="primary" @click="handleAdd">{{this.$t('page.tending.add')}}</b-button>
    </div>
  </div>
</template>

<script>
import MessageBox from "@/components/common/MessageBox.vue";
import {
  maintenanceItemList
} from "@/utils/selectText";
export default {
  emits: ["update:repairs"],
  props: {
    submitted: Boolean,
    validationTips: Object,
    repairs: {
      type: Array,
      default: () => {
        return [
          {
            item_name: "",
            name: '',
            cycle: '',
            description: "",
          },
        ];
      },
    },
  },
  data() {
    return {
      titleList: [
        {
          name: this.$t('page.tending.item'),
          required: true,
        },
        {
          name: this.$t('page.tending.names'),
          required: true,
        },
        {
          name: this.$t('page.tending.maintenance_period'),
          required: true,
        },
        {
          name: this.$t('page.tending.description'),
          required: false,
        },
      ],
      showRepairs: [],
      cycleOptions: [],
      tagMessageBox: null,
      focusactive: null,
      maintenanceItemList,
    };
  },
  components: {
    MessageBox,
  },
  watch: {
    showRepairs: {
      handler(newVal) {
        if (!this.cycleOptions.length) {
          // 初始化没有周期选项时，根据每一行对应的维护保养名称，获取对应的周期选项
          this.cycleOptions = newVal.map((item) => {
            if (item.is_deleted) {
              return [];
            }
            const maintenanceItem = maintenanceItemList.find(
              (maintenanceItem) => maintenanceItem.value === item.name
            );
            if (maintenanceItem) {
              return maintenanceItem.cycleList;
            } else {
              return [];
            }
          });
        }
        this.$emit("update:repairs", newVal);
      },
      deep: true,
    },
    repairs: {
      handler(newVal) {
        this.showRepairs = newVal;
      },
      deep: true,
    },
  },
  methods: {
    nameChange(value, i) {
      if (!value) {
        this.cycleOptions[i] = [];
        this.showRepairs[i]['cycle'] = '';
      }
      const item = maintenanceItemList.find((item) => item.value === value);
      if (item) {
        this.cycleOptions[i] = item.cycleList;
        this.showRepairs[i]['cycle'] = item.defaultCycle;
      } else {
        this.cycleOptions[i] = [];
        this.showRepairs[i]['cycle'] = '';
      }
    },
    handleAdd() {
      this.tagMessageBox = null;
      let defaultData = {
        item_name: "",
        name: '',
        cycle: '',
        description: "",
      };
      const item = { ...defaultData }
      const validList = this.showRepairs.filter((item) => !item.is_deleted);
      if (validList.length) {
        const lastOne = validList[validList.length - 1];
        item.name = lastOne.name
        item.cycle = lastOne.cycle;
        const maintenanceItem = maintenanceItemList.find(
          (maintenanceItem) => maintenanceItem.value === lastOne.name
        );
        if (maintenanceItem) {
          this.cycleOptions.push(maintenanceItem.cycleList);
        } else {
          this.cycleOptions.push([]);
        }
      } else {
        this.cycleOptions.push([])
      }
      this.showRepairs.push(item);
    },
    handleDelete(i) {
      if (this.showRepairs[i].id) {
        this.showRepairs[i].is_deleted = true;
      } else {
        this.showRepairs.splice(i, 1);
        this.cycleOptions.splice(i, 1);
      }
      this.tagMessageBox = null;
    },
  },
};
</script>
<style scoped>
/* 外层div */
.father_box {
  box-sizing: border-box;
  background-color: white;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 12px;
  text-align: left;
  padding-left: 15px;
  word-wrap: break-word;
  overflow: hidden;
  color: #212529;
}
.focus {
  border-color: #b3c8f3;
  outline: 0;
  box-shadow: 0 0 0 0 rgb(102 145 231 / 25%);
}
/* 标签 */
.spanbox {
  display: inline-block;
  font-size: 14px;
  margin: 5px 4px 5px 0;
  background-color: #6691e7;
  border: 1px solid #e8eaec;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
/* 标签文字 */
.tagspan {
  height: 24px;
  line-height: 22px;
  max-width: 99%;
  position: relative;
  display: inline-block;
  padding-left: 8px;
  color: #fff;
  font-size: 14px;
  opacity: 1;
  vertical-align: middle;
  overflow: hidden;
  transition: 0.25s linear;
}
/* tag的叉叉 */
.span_close {
  padding: 0 6px 0 4px;
  opacity: 1;
  -webkit-filter: none;
  filter: none;
  color: #fff;
  /* font-weight: 600; */
  cursor: pointer;
}
/* 鼠标经过叉叉 */
.span_close:hover {
  background-color: #409eff;
  border-radius: 50%;
  color: #fff;
}
.span_close:after {
  content: "\00D7";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* line-height: 27px; */
  transition: 0.3s, color 0s;
}
/* input */
.inputTag {
  font-size: 16px;
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  width: auto;
  min-width: 150px;
  vertical-align: top;
  height: 35.5px;
  color: #495060;
  line-height: 35.5px;
}
/* 输入框提示文字大小 */
input:placeholder-shown {
  font-size: 0.8125rem;
}
</style>
